import { parseUnits } from '@ethersproject/units'

export const MINT_COST = parseUnits('1')
export const REGISTER_COST = parseUnits('0.5')
export const ALLOWANCE_MULTIPLIER = 5
export const STARTER_BUNNY_IDENTIFIERS = ['sleepy', 'dollop', 'twinkle', 'churro', 'sunny']
export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 15
